import React from 'react';
import {Navigate} from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import MainLayout from '../layouts/MainLayout';
import LoginView from '../views/auth/LoginView';
import SignUp from '../views/singup/SingUp';
import NotFoundView from '../views/errors/NotFoundView';
import SettingsView from '../views/settings/SettingsView';
import Dashboard from "../views/dashboard";
import Withdrawal from "../views/withdrawal";
import Logout from "../views/logout";

const getRoutes = (user) => {
    if (user){
        return [
            {
                path: '/',
                element: <DashboardLayout/>,
                children: [
                    {path: '/', element: <Navigate to="/dashboard"/>},
                    {path: 'dashboard', element: <Dashboard/>},
                    user.withdrawalAuth && {path: 'withdrawal', element: <Withdrawal/>},
                    {path: 'settings', element: <SettingsView/>},
                    {path: 'logout', element: <Logout />},
                    {path: '404', element: <NotFoundView/>},
                    {path: 'singup', element: <Navigate to="/dashboard"/>},
                    {path: '*', element: <Navigate to="/404"/>}
                ]
            }
        ]
    }else{
        return [
            {
                path: '/',
                element: <MainLayout/>,
                children: [
                    {path: '/', element: <LoginView/>},
                    {path: '/singup', element: <SignUp/>},
                    {path: '*', element: <Navigate to="/"/>}
                ]
            }
        ]
    }


};



export default getRoutes;
